import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

import {
  ToolDetailBody,
  ToolDetailHeader,
  ToolDetailReviews,
  LoadingIcon,
} from "../../components";
import { ReviewOverlay } from "../";
import {
  fetchCurrentTool,
  fetchAllReviews,
} from "../../store/modules/tools.module";
import "./ToolDetail.sass";

const SHOW_COMMUNITY_REVIEWS = false;

class ToolDetail extends Component {
  state = {
    isOpenReviewOverlay: false,
  };

  constructor() {
    super();
    this._toggleReviewOverlay = this.toggleReviewOverlay.bind(this);
  }

  componentDidMount() {
    if (SHOW_COMMUNITY_REVIEWS) {
      // Check URL to see if we should go right to the review overlay
      if (this.props.location.hash === "#review") {
        this.setState({ isOpenReviewOverlay: true }, () => {
          this.props.history.replace({
            ...this.props.location,
            hash: "",
          });
        });
      }

      this.props.fetchAllReviews(this.props.match.params.slug);
    }

    this.props.fetchCurrentTool(this.props.match.params.slug);
  }

  toggleReviewOverlay() {
    this.setState({ isOpenReviewOverlay: !this.state.isOpenReviewOverlay });
  }

  render() {
    const { isOpenReviewOverlay } = this.state;
    const { currentTool, reviews } = this.props;

    // Show review overlay if it's supposed to be open regardless of whether the tool data has loaded
    const reviewOverlay = SHOW_COMMUNITY_REVIEWS ? (
      <ReviewOverlay
        isVisible={isOpenReviewOverlay}
        toggleReviewOverlay={this._toggleReviewOverlay}
      />
    ) : null;

    if (currentTool.isFetching) {
      return (
        <div className="center-vertical-wrapper">
          <LoadingIcon />
          {reviewOverlay}
        </div>
      );
    }

    if (currentTool.hasError) {
      return (
        <div className="center-vertical-wrapper">
          <h3>Error loading tool</h3>
          {reviewOverlay}
        </div>
      );
    }

    return (
      <div className="tool-detail-container">
        <Helmet>
          <title>{currentTool.data.name} | Gulf TREE</title>
        </Helmet>
        <ToolDetailHeader tool={currentTool.data} />
        <ToolDetailBody tool={currentTool.data} />
        {SHOW_COMMUNITY_REVIEWS && (
          <ToolDetailReviews
            toggleReviewOverlay={this._toggleReviewOverlay}
            reviews={reviews.data}
          />
        )}
        {reviewOverlay}
      </div>
    );
  }
}

ToolDetail.propTypes = {
  currentTool: PropTypes.object,
  fetchCurrentTool: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  fetchAllReviews: PropTypes.func,
  createReview: PropTypes.func,
};

const mapStateToProps = ({ tools }) => ({
  currentTool: tools.currentTool,
  reviews: tools.reviews,
});

export default connect(mapStateToProps, { fetchCurrentTool, fetchAllReviews })(
  ToolDetail,
);
